export default __webpack_public_path__ + "static/media/frens-gif-new.c99b4e37.gif";